import { render, staticRenderFns } from "./truck-edit-form.html?vue&type=template&id=251796aa&scoped=true&"
import script from "./truck-edit-form.ts?vue&type=script&lang=js&"
export * from "./truck-edit-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251796aa",
  null
  
)

export default component.exports